module.exports = __webpack_public_path__ + "static/media/squiggle.ab43297a.svg";